import { Stack } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';

import { EvaluationReportTable } from '@/module/Evaluation/components/EvaluationReportTable';
import { EvaluationReportTotalTable } from '@/module/Evaluation/components/EvaluationReportTotalTable';
import { getEvaluationOverviewOptions } from '@/module/Evaluation/model/EvaluationQuery';

import { Id } from '@/feature/utils';

interface EvaluationReportTablesProps {
  evaluationId: Id;
  authorId: Id;
  isEvaluationClosed: boolean;
}

export function EvaluationReportTables({ evaluationId, authorId, isEvaluationClosed }: EvaluationReportTablesProps) {
  const {
    data: {
      map,
      totalAuthorPoints,
      totalAuthorCategoryPoints,
      totalAuthorMeritPoints,
      totalHeadOfDisciplinePoints,
      totalHeadOfDisciplineCategoryPoints,
      totalHeadOfDepartmentMeritPoints,
      totalHeadOfDepartmentPoints,
      totalHeadOfDepartmentCategoryPoints,
      totalHeadOfDisciplineMeritPoints,
    },
  } = useSuspenseQuery(getEvaluationOverviewOptions(evaluationId, authorId));

  return (
    <Stack>
      <EvaluationReportTable
        evaluationId={evaluationId}
        category="DIDACTIC_PROFESSIONAL_ACTIVITY"
        overview={map.DIDACTIC_PROFESSIONAL_ACTIVITY}
      />
      <EvaluationReportTable
        evaluationId={evaluationId}
        category="SCIENTIFIC_ACTIVITY"
        overview={map.SCIENTIFIC_ACTIVITY}
      />
      <EvaluationReportTable
        evaluationId={evaluationId}
        category="COMMUNITY_REACH_ACTIVITY"
        overview={map.COMMUNITY_REACH_ACTIVITY}
      />
      <EvaluationReportTotalTable
        title="Autor"
        totalPoints={totalAuthorPoints}
        totalCategoryPoints={totalAuthorCategoryPoints}
        totalMeritPoints={totalAuthorMeritPoints}
      />
      {isEvaluationClosed && (
        <EvaluationReportTotalTable
          title="Șef de disciplină"
          totalPoints={totalHeadOfDisciplinePoints}
          totalCategoryPoints={totalHeadOfDisciplineCategoryPoints}
          totalMeritPoints={totalHeadOfDisciplineMeritPoints}
        />
      )}
      {isEvaluationClosed && (
        <EvaluationReportTotalTable
          title="Director departament"
          totalPoints={totalHeadOfDepartmentPoints}
          totalCategoryPoints={totalHeadOfDepartmentCategoryPoints}
          totalMeritPoints={totalHeadOfDepartmentMeritPoints}
        />
      )}
    </Stack>
  );
}
